import { range } from 'lodash';

import { answerSelector } from 'selectors/answerSelectors';

const SLIDER_TYPE = 'slider';

function processRange(producer, question) {
  const { display_type } = question;
  const { parameters } = producer;
  if (display_type === SLIDER_TYPE) {
    return {
      min: parameters.start,
      max: parameters.end,
      step: parameters.step_size,
      labels: parameters.labels,
    };
  } else {
    return range(parameters.start, parameters.end, parameters.step_size).map(
      val => {
        return { value: val, text: val.toString() };
      }
    );
  }
}

function processStaticList(producer) {
  return producer.parameters.items.map(item => {
    return {
      ...item,
      value: item.id,
    };
  });
}

function processDynamicList(producer, question, state) {
  let targetKey = producer.parameters.target;
  let targetAnswer = answerSelector(state, producer.parameters.source);
  return producer.parameters.items.filter(item => {
    return item[targetKey] === targetAnswer;
  });
}

export function processProducer(producer, question, state) {
  switch (producer.type) {
    case 'StaticList':
      return processStaticList(producer, question);
    case 'DynamicList':
      return processDynamicList(producer, question, state);
    case 'Range':
      return processRange(producer, question);
    default:
      throw new Error(`Don't know the producer type of ${producer.type}`);
  }
}

export function processChoices(question, state) {
  if (question.choices) {
    return processProducer(question.choices.producer, question, state);
  }
}

export function getDefaultValue(question) {
  if (question.choices) {
    return question.choices.default_value;
  }
}



// WEBPACK FOOTER //
// ./src/services/choiceProducerService.js